import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class InventarioFisicoDetalleService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }


  agregarProductoInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number,
      sucursal_codigo: number,
      bodega_codigo: number,
      producto_codigo: number,
      formato_codigo: string
    },
    detalle:
    {
      rut_empresa: number,
      sucursal_codigo: number,
      producto_codigo: number,
      sku: string,
      producto_nombre: string
      formato_codigo: string
      formato_nombre: string
      bodega_codigo: number,
      bodega_nombre: string
      rubro_codigo: number,
      rubro_nombre: string
      familia_codigo: number,
      familia_nombre: string
    }[],
    paginaActual: number,
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico_detalle {
            agregarProductoInventarioFisico(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  saldo_actual
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico_detalle.agregarProductoInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerProductoInventarioFisico(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      bodega_codigo: number
      listaRubro: any[]
      listaFamilia: any[]
      filtraSaldo: boolean
      mayorCero: boolean
    },
    detalle: any[]
    paginaActual: number,
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico_detalle {
            obtenerProductoInventarioFisico(entidad: $entidad, detalle: $detalle, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  producto_nombre
                  sku
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  saldo_actual
                }
              }
            }
          }
        }        
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico_detalle.obtenerProductoInventarioFisico
        callback({ mensajes, respuesta })
      }
    );
  }

  agregarProductoTomaInventario(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      bodega_codigo: number
      producto_codigo: number
      formato_codigo: string
    },
    detalle: any[]
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: inventario_fisico_detalleInputType, $detalle: [inventario_fisico_detalleInputType]) {
          inventario_fisico_detalle {
            agregarProductoTomaInventario(entidad: $entidad, detalle: $detalle) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  cantidad_contada
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.inventario_fisico_detalle.agregarProductoTomaInventario
        callback({ mensajes, respuesta })
      }
    );
  }

}
